// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".aircraft-type[data-v-054c9a2a]  .el-form-item__content {\n  width: 7.5em;\n}", ""]);
// Exports
module.exports = exports;
